var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pui-input',{ref:"editor",attrs:{"type":"text","disabled":_vm.editor.disabled,"value":_vm.getValue,"textarea":_vm.editor.textarea},on:{"change":_vm.onValueChanged,"blur":_vm.onBlur}})
}
var staticRenderFns = []

export { render, staticRenderFns }